module.exports = __webpack_public_path__ + "static/img/wx.b2675c41.jpg";